<template>
  <div class="form">
    <div v-show="!loading">
      <h1>{{ $lang("2021夏日競技嘉年華") }}</h1>
      <b-form @submit="onSubmit">
        <div class="form-header">
          <div class="checkbox-group">
            <p class="checkbox-attention-text">
              <span>{{ $lang("TEXT_ATTENTION_CHECKBOX") }}</span>
            </p>
            <template v-if="isAdultCaptain">
              <ol class="checkbox-attention">
                <li>
                  {{ $lang("ATTENTION_ONE") }}(<a :href="url" target="_blank">{{
                    $lang("TITLE_HEALTH_DOWN_URL")
                  }}</a
                  >).{{ $lang("ATTENTION_TWO") }}
                </li>
                <li>{{ $lang("ATTENTION_THREE") }}</li>
              </ol>
              <p class="checkbox-attention-text">
                <span>{{ $lang("TEXT_ACCEPT_CHECKBOX") }}</span>
              </p>
              <b-form-checkbox v-model="form.isAgree1" :disabled="is_perview">
                <span class="lbl">{{ $lang("TEXT_ACCEPT_SELF") }}</span>
              </b-form-checkbox>
            </template>
            <template v-else>
              <p>
                <span
                  >{{ $lang("ATTENTION_FOUR_FIRST") }}(<a
                    :href="url"
                    target="_blank"
                    >{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a
                  >){{ $lang("ATTENTION_FOUR_LAST") }}</span
                >
              </p>
            </template>
            <div class="upload-check" :disabled="is_perview">
              <InputFile
                accept=".jpg, .png, .gif, .pdf"
                v-model="form.healthFile"
                :word="$lang('BTN_UPLOAD_FILE')"
                :disabled="is_perview"
              />
              <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
            </div>
          </div>
          <div v-if="is_group || isType" class="checkbox-group">
            <div
              v-if="is_group || isType"
              class="upload-check"
              :disabled="is_perview"
            >
              <InputFile
                accept=".jpg, .png, .gif, .pdf"
                v-model="form.managerFile"
                :word="$lang('BTN_UPLOAD_FILE_GROUP')"
                :disabled="is_perview"
              />
              <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
            </div>
          </div>
        </div>
        <b-form-group :label="$lang('FIELD_CHILD_GROUP_NAME')">
          <b-form-input
            type="text"
            v-model="form.teamName"
            v-validate="'required'"
            name="teamName"
            :class="errors.has('teamName') && 'is-invalid'"
            :placeholder="$lang('請輸入隊伍名稱')"
            :disabled="is_perview"
          />
          <b-form-invalid-feedback :state="errors.has('teamName')">
            {{ errors.first("teamName") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <p>{{ $lang("隊伍名單") }}</p>
        <h4>{{ $lang("隊長") }}</h4>
        <div>
          <b-row>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('姓：')"
                :feedback="errors.first('firstName')"
              >
                <b-form-input
                  type="text"
                  v-model="form.teamCaptain.firstName"
                  name="firstName"
                  :class="errors.has('firstName') && 'is-invalid'"
                  v-validate="'required'"
                  :placeholder="$lang('請輸入姓氏')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('firstName')">
                  {{ errors.first("firstName") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group horizontal :label-cols="3" :label="$lang('名字：')">
                <b-form-input
                  type="text"
                  v-model="form.teamCaptain.lastName"
                  name="lastName"
                  :class="errors.has('lastName') && 'is-invalid'"
                  v-validate="'required'"
                  :placeholder="$lang('請輸入名字')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('lastName')">
                  {{ errors.first("lastName") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('出生日期：')"
              >
                <DatePicker
                  type="date"
                  v-model="form.teamCaptain.bornAt"
                  name="bornAt"
                  size="large"
                  :class="errors.has('bornAt') && 'is-invalid'"
                  v-validate="'required|conforming_Summertime_age:1972,2007'"
                  format="yyyy/MM/dd"
                  :disabled="is_perview"
                ></DatePicker>
                <b-form-invalid-feedback :state="errors.has('bornAt')">
                  {{ errors.first("bornAt") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
                <b-select
                  v-model="form.teamCaptain.gender"
                  name="sex"
                  :class="errors.has('sex') && 'is-invalid'"
                  v-validate="'required'"
                  :placeholder="$lang('請輸入性別')"
                  :disabled="is_perview"
                >
                  <option value="M">{{ $lang("FIELD_MALE") }}</option>
                  <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
                </b-select>
                <b-form-invalid-feedback :state="errors.has('sex')">
                  {{ errors.first("sex") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('FIELD_ID_NUMBER_TYPE')"
              >
                <b-input-group>
                  <b-form-select
                    v-model="form.teamCaptain.idType"
                    name="idType"
                    :class="errors.has('idType') && 'is-invalid'"
                    v-validate="'required'"
                    :disabled="is_perview"
                  >
                    <option value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
                    <option value="2">
                      {{ $lang("TEXT_ID_TYPE_PASSPORT") }}
                    </option>
                    <option value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
                  </b-form-select>
                  <b-form-invalid-feedback :state="errors.has('idType')">{{
                    errors.first("idType")
                  }}</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('FIELD_ID_NUMBER')"
              >
                <b-form-input
                  type="text"
                  v-model="form.teamCaptain.idNumber"
                  name="idNumber"
                  :class="errors.has('idNumber') && 'is-invalid'"
                  v-validate="{ required: true, idNumber: isIdentity }"
                  :placeholder="$lang('請輸入證件號碼')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('idNumber')">
                  {{ errors.first("idNumber") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group horizontal :label-cols="3" :label="$lang('電郵：')">
                <b-form-input
                  type="text"
                  v-model="form.teamCaptain.email"
                  name="email"
                  :class="errors.has('email') && 'is-invalid'"
                  v-validate="'required|email'"
                  :placeholder="$lang('請輸入電郵')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('email')">
                  {{ errors.first("email") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('電話號碼：')"
              >
                <b-form-input
                  type="text"
                  v-model="form.teamCaptain.phone"
                  name="phone"
                  :class="errors.has('phone') && 'is-invalid'"
                  v-validate="'required|mobile'"
                  :placeholder="$lang('請輸入電話')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('phone')">
                  {{ errors.first("phone") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <h4>{{ $lang("隊員") }}</h4>
        <template v-for="item in form.teamMembers">
          <summer-form
            :isIndividual="false"
            :requiredType="requiredType"
            :key="item.key"
            :value.sync="item"
            :rules="rules"
            class="dashed"
            ref="form-item"
            :disabled="is_perview"
          >
            <template v-if="form.teamMembers.length > 4" v-slot:remove>
              <b-form-group horizontal>
                <label slot="label"></label>
                <b-btn
                  variant="info"
                  size="sm"
                  class="del"
                  @click.prevent="handleRemove(item)"
                  ><i class="fa fa-trash-o" style="margin-right: 5px"></i
                  >{{ $lang("刪除") }}</b-btn
                >
              </b-form-group>
            </template>
          </summer-form>
        </template>
        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <b-btn
                v-if="form.teamMembers.length < 6"
                variant="success btn-round"
                @click.prevent="handleAdd"
                >+{{ $lang("添加參賽者") }}</b-btn
              >
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="is_Full || isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p v-html="$lang('TITLE_FORM_TIP')"></p>
          </div>
        </div>
      </b-form>
    </div>
    <div class="spinner" v-show="loading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import SummerForm from "@/components/SummerFormNoVaccination";
import InputFile from "@/components/InputFile";
import utils from "@/helper/utils";
export default {
  props: {
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    InputFile,
    SummerForm,
  },
  data() {
    return {
      loading: true,
      validate_pass: false,
      index: 4,
      isIdentity: true,
      isType: false,
      requiredType: false,
      status: "",
      isDisable: false,
      rules: {
        birth: {
          conforming_Summertime_age: [1972, 2007],
        },
        idNumber: {
          idNumber: true,
        },
      },
      form: {
        id: null,
        healthFile: "",
        managerFile: "",
        isAgree1: null,
        isAgree2: null,
        teamName: null,
        teamCaptain: {
          lastName: null,
          firstName: null,
          bornAt: "",
          gender: null,
          idType: 1,
          idNumber: "",
          email: null,
          phone: null,
        },
        teamMembers: [
          {
            lastName: "123",
            firstName: "ASDA",
            gender: "F",
            bornAt: "1974-05-08",
            idType: 1,
            idNumber: "51515151",
          },
          {
            lastName: "123",
            firstName: "ASDA",
            gender: "F",
            bornAt: "2007-05-18",
            idType: 3,
            idNumber: "51111111",
          },
          {
            lastName: "試",
            firstName: "ASDA",
            gender: "F",
            bornAt: "1998-09-25",
            idType: 3,
            idNumber: "0101",
          },
          {
            lastName: "159753",
            firstName: "ASDA",
            gender: "M",
            bornAt: "2001-05-16",
            idType: 3,
            idNumber: "515151511",
          },
        ],
        // teamMembers: [
        //   {
        //     lastName: null,
        //     firstName: null,
        //     gender: null,
        //     bornAt: "",
        //     idType: 1,
        //     idNumber: "",
        //   },
        //   {
        //     lastName: null,
        //     firstName: null,
        //     gender: null,
        //     bornAt: "",
        //     idType: 1,
        //     idNumber: "",
        //   },
        //   {
        //     lastName: null,
        //     firstName: null,
        //     gender: null,
        //     bornAt: "",
        //     idType: 1,
        //     idNumber: "",
        //   },
        //   {
        //     lastName: null,
        //     firstName: null,
        //     gender: null,
        //     bornAt: "",
        //     idType: 1,
        //     idNumber: "",
        //   },
        // ],
      },
    };
  },
  methods: {
    save() {
      this.requiredType = false;
      this.status = "draft";
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.form.teamCaptain.bornAt =
        this.$changeTime(this.form.teamCaptain.bornAt) || "";
      // var isInst = this.is_group ? this.is_group : this.isType
      // 今年只有公開組
      var isInst = false;
      var params = {
        ...this.form,
        status: this.status,
        publicType: isInst ? "publicInstitutionsGroup" : "publicGroup",
        teamMembers: this.uploadMembers(this.form.teamMembers),
      };
      if (params.teamName == "") {
        return false;
      }
      if (this.status == "draft") {
        this.recordUpdate(params);
        this.errorScoll();
      } else {
        if (!isInst) delete params.managerFile;
        var noChild = this.noChild(params);
        var promise_list = this.$refs["form-item"].map((item) =>
          item.onSubmit()
        );
        var isAdultCaptain = this.isAdultCaptain;
        this.$validator.validate().then((validate) => {
          console.log(validate);
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            var validateObject = this.validateForm(params);
            var isRight = Object.keys(validateObject).every(
              (item) => validateObject[item]
            );
            this.errorScoll();
            if (isAdultCaptain) {
              if (!params.isAgree1 && !params.healthFile) {
                this.notification.warning(this.$lang("TEXT_WARNING_2"));
              } else if (!params.healthFile && params.isAgree1) {
                this.notification.warning(this.$lang("TEXT_WARNING_1"));
              } else if (isInst && !params.managerFile) {
                this.notification.warning(this.$lang("TEXT_WARNING_4"));
              } else {
                if (params.healthFile) {
                  console.log(123, result, isRight, validate);
                  if (result && isRight && validate) {
                    this.recordUpdate(params);
                    this.errorScoll();
                  }
                }
              }
            } else {
              if (!params.healthFile) {
                this.notification.warning(this.$lang("TEXT_WARNING_1"));
              } else if (isInst && !params.managerFile) {
                this.notification.warning(this.$lang("TEXT_WARNING_4"));
              } else {
                if (result && isRight && validate) {
                  this.recordUpdate(params);
                  this.errorScoll();
                }
              }
            }
          });
        });
      }
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    noChild(form) {
      let noChild = true;
      let teamMembers = form.teamMembers;
      let teamCaptain = form.teamCaptain;
      teamMembers.forEach((item, index) => {
        const bornAt = item.bornAt;
        const year = utils.getYear(bornAt);
        if (year > 2004 && year <= 2006) {
          noChild = false;
        }
      });
      if (
        utils.getYear(teamCaptain.bornAt) > 2004 &&
        utils.getYear(teamCaptain.bornAt) <= 2006
      ) {
        noChild = false;
      }
      return noChild;
    },
    idNumberRepear(form) {
      let teamMembers = form.teamMembers;
      let teamCaptain = form.teamCaptain;
      let list = teamMembers.map((item) => item.idNumber);
      let list_all = [teamCaptain.idNumber, ...list];
      return utils.isRepeat(list_all);
    },
    validateForm(form) {
      let teamMembers = form.teamMembers;
      let teamCaptain = form.teamCaptain;
      let list = teamMembers.map((item) => item.idNumber);
      list.push(teamCaptain.idNumber);
      let conforming_age = true;
      let hasfemale = false;
      teamMembers.forEach((item, index) => {
        const bornAt = item.bornAt;
        const gender = item.gender;
        const year = utils.getYear(bornAt);
        if (year < 1972 || year > 2007) {
          conforming_age = false;
        }
        if (gender === "F") {
          hasfemale = true;
        }
      });
      if (
        utils.getYear(teamCaptain.bornAt) < 1972 ||
        utils.getYear(teamCaptain.bornAt) > 2007
      ) {
        conforming_age = false;
      }
      if (teamCaptain.gender === "F") {
        hasfemale = true;
      }
      if (!hasfemale) {
        this.notification.warning(this.$lang("至少有一名為女性"));
      }
      return {
        conforming_age,
        hasfemale,
      };
    },
    handleRemove(item) {
      if (this.form.teamMembers.length <= 4) {
        return;
      }
      var index = this.form.teamMembers.indexOf(item);
      if (index !== -1) {
        this.form.teamMembers.splice(index, 1);
      }
    },
    handleAdd() {
      this.index++;
      this.form.teamMembers.push({
        index: this.index,
        lastName: null,
        firstName: null,
        gender: null,
        bornAt: "",
        idType: 1,
        idNumber: "",
      });
    },
    uploadMembers(list) {
      return list.map((item) => {
        delete item["key"];
        delete item["index"];
        item.bornAt = this.$changeTime(item.bornAt) || "";
        return item;
      });
    },
    recordUpdate(params) {
      if (this.status == "draft") {
        this.saveForm(params)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "summer-carnival",
            });
          })
          .catch((err) => {
            if (err.data.teamCaptain) {
              this.errors.add({
                field: err.data.teamCaptain.path,
                msg: err.data.teamCaptain.message,
              });
              this.notification.error(this.$lang(err.data.teamCaptain.message));
            }
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              var teamMembers = err.data.teamMembers;
              var that = this;
              Object.keys(teamMembers).forEach(function (key) {
                that.$refs["form-item"][key].validateErrors(
                  teamMembers[key].path,
                  that.$lang(teamMembers[key].message)
                );
                that.notification.error(that.$lang(teamMembers[key].message));
              });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      } else {
        this.recordPro(params)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            // } else {
            //     this.notification.success(this.$lang("新增成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "summer-carnival",
            });
          })
          .catch((err) => {
            if (err.code === 10006) {
              console.log(err);
              this.notification.error(this.$lang(err.message));
              return false;
            }
            if (err.data.teamCaptain) {
              this.errors.add({
                field: err.data.teamCaptain.path,
                msg: err.data.teamCaptain.message,
              });
              this.notification.error(this.$lang(err.data.teamCaptain.message));
            }
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              var teamMembers = err.data.teamMembers;
              var that = this;
              Object.keys(teamMembers).forEach(function (key) {
                that.$refs["form-item"][key].validateErrors(
                  teamMembers[key].path,
                  that.$lang(teamMembers[key].message)
                );
                that.notification.error(that.$lang(teamMembers[key].message));
              });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      }
    },
    recordPro(params) {
      // 防止連續點擊重複提交
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
      return new Promise((resolve, reject) => {
        this.$apis.carnival
          .recordUpdate(params)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 保存
    saveForm(params) {
      // 防止連續點擊重複提交
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
      return new Promise((resolve, reject) => {
        this.$apis.carnival
          .saveForm(params)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    recordDetail(id) {
      if (this.mode === "perview") {
        this.loading = true;
        $apis.carnival
          .recordDetail({ id })
          .then((resp) => {
            this.form = resp.data;
            if (resp.data.publicType === "publicGroup") this.isType = false;
            else this.isType = true;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        $apis.carnival
          .loadForm({ id })
          .then((resp) => {
            this.form = resp.data;
            if (resp.data.publicType === "publicGroup") this.isType = false;
            else this.isType = true;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          var data = resp.data;
          this.form.teamCaptain = {
            lastName: data.lastNameZh || data.lastNamePt,
            firstName: data.firstNameZh || data.firstNamePt,
            bornAt: data.bornAt,
            gender: data.gender,
            idType: data.idType,
            idNumber: data.idNumber,
            email: null,
            phone: null,
          };
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    is_Full() {
      if (this.$route.query.isFull == true) {
        return true;
      } else {
        return false;
      }
    },
    is_group() {
      return this.$route.query.type;
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/healthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
    isAdultCaptain() {
      var value = this.form.teamCaptain.bornAt;
      if (!value) return false;
      var year = new Date(value).getFullYear();
      let result = year >= 1971 && year <= 2006;
      if (!result) {
        this.form.isAgree1 = null;
        this.form.isAgree2 = null;
      }
      return result;
    },
  },
  created() {
    var id = this.$route.params.slug;
    var isNew = this.is_new;
    this.form.id = id;
    id && this.recordDetail(id);
    isNew && this.getUserInfo();
  },
  watch: {
    "form.teamCaptain.idType": {
      handler(n) {
        if (n == "1") {
          this.isIdentity = true;
        } else {
          this.isIdentity = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
